// extracted by mini-css-extract-plugin
module.exports = {"priceWithDiscount":"_2s8kTJ","shine-lines":"_2g6Agg"};